import { useTranslation } from "react-i18next";

import {
  ProductCardChip,
  simStatusToProductCardChipTone,
} from "@/components/Layout/BaseLayouts/ProductCard/ProductCardChip";
import {
  NumberPorting,
  NumberPortingStatus,
  SimCardDetailSimStatus,
} from "@/services/model";

const statusLabelKey: Record<SimCardDetailSimStatus, string> = {
  green: "layout.tiles.statusChip.active",
  yellow: "layout.tiles.statusChip.active",
  red: "layout.tiles.statusChip.suspended",
  grey: "layout.tiles.statusChip.inactive",
  orange: "cockpit.filter.status-labels.onpPending",
};

export const SimStatusChip = ({
  status,
  numberPorting,
}: {
  status?: SimCardDetailSimStatus;
  /** When set, the chip matches the number-porting tile instead of simStatus. */
  numberPorting?: NumberPorting;
}) => {
  const { t } = useTranslation("portal");

  // Orange ("missing info") already maps to the pending-porting label below.
  // A SIM that is still grey/yellow while porting would otherwise read as
  // inactive/active — the tile uses the porting copy, so the header must too.
  if (status !== SimCardDetailSimStatus.orange) {
    if (numberPorting?.status === NumberPortingStatus.dateKnown) {
      return (
        <ProductCardChip
          label={t("layout.tiles.numberPorting.numberBeingTransferred")}
          tone="info"
        />
      );
    }

    if (numberPorting) {
      return (
        <ProductCardChip
          label={t("cockpit.filter.status-labels.onpPending")}
          tone="warning"
        />
      );
    }
  }

  if (!status) {
    return null;
  }

  return (
    <ProductCardChip
      label={t(statusLabelKey[status] as any)}
      tone={simStatusToProductCardChipTone[status]}
    />
  );
};
